import { useDispatch } from 'react-redux';

const SET_FOCUSED_FIELD_PROPS = 'SET_FOCUSED_FIELD';
const UPDATE_FOCUSED_VALUE = 'UPDATE_FOCUSED_VALUE';
const UNSET_PROPS = 'UNSET_PROPS';

const setFocusedFieldProps = ({ id, shortcuts, value, changeHandler }) => {
    return {
        type: SET_FOCUSED_FIELD_PROPS,
        payload: {
            id,
            shortcuts,
            value,
            changeHandler,
        },
    };
};

const useSetFocusedFieldProps = () => {
    const dispatch = useDispatch();

    return ({ id, shortcuts, value, changeHandler }) =>
        dispatch(
            setFocusedFieldProps({
                id,
                shortcuts,
                value,
                changeHandler,
            })
        );
};

const unsetFocusedFieldProps = () => {
    return { type: UNSET_PROPS };
};

const useUnsetFocusedFieldProps = () => {
    const dispatch = useDispatch();

    return () => dispatch(unsetFocusedFieldProps());
};

const updateFocusedValue = (update) => {
    return { type: UPDATE_FOCUSED_VALUE, payload: update };
};

const useUpdateFocusedValue = () => {
    const dispatch = useDispatch();

    return (update) => dispatch(updateFocusedValue(update));
};

export {
    SET_FOCUSED_FIELD_PROPS,
    setFocusedFieldProps,
    UNSET_PROPS,
    unsetFocusedFieldProps,
    UPDATE_FOCUSED_VALUE,
    updateFocusedValue,
    useSetFocusedFieldProps,
    useUnsetFocusedFieldProps,
    useUpdateFocusedValue,
};
